var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',_vm._g({staticClass:"itextarea_item",attrs:{"name":_vm.name,"placeholder":_vm.placeholder,"rows":_vm.rows},domProps:{"value":_vm.value},on:{"focus":_vm.handleFocus}},_vm.inputListeners))}
var staticRenderFns = []

export { render, staticRenderFns }